// Alby Brand ID for SimpliSafe
const ALBY_BRAND_ID = '6cab567f-eac6-47da-a675-76af39510e75'
// Alby Widget ID for Generative Prompts Widget
const ALBY_GENERATIVE_PROMPTS_PLP_ID = 'a2945ab2-50fe-4675-800a-72355d2af222'
// Alby Widget ID for PDP (Product Detail Page)
const ALBY_GENERATIVE_PROMPTS_PDP_ID = 'c34eac12-9997-4030-88c1-e0df3865d8bd'
// Alby Widget ID for floating Chat Bot
const ALBY_CHAT_BOT_ID = 'f6c59772-1de6-47d9-9489-2257e0693b81'
// Alby Widget ID for FPP (Product Landing Pages)
const ALBY_GENERATIVE_PROMPTS_FPP_ID = '750226ac-fb9b-4f9f-b278-3acdf406e5b5'
// Contentful Experiment ID for Alby
const ALBY_CHAT_EXPERIMENT_ID = '1c9CEqWqWMDYKViD1lH69H'

const ALBY_GENERATIVE_PROMPTS_SA_LANDING_ID =
  'd13bec57-8be8-467f-b9b2-a330cc63c9ed'

const ALBY_GENERATIVE_PROMPTS_SA_ENTRY_ID =
  '182a6fe1-2f48-411e-9f82-1d2ab200188e'

const ALBY_GENERATIVE_PROMPTS_SA_INDOOR_ID =
  '1bba8153-1c23-4e7e-b1a3-6dd994468569'

const ALBY_GENERATIVE_PROMPTS_SA_OUTDOOR_ID =
  'a0a21e1a-65d4-45f6-b071-da4c7431fd4c'
// BMS
const ALBY_GENERATIVE_PROMPTS_BMS_BURGLARY_ID =
  '6c5c8034-6b07-45ac-8c14-d2862eb08f85'
const ALBY_GENERATIVE_PROMPTS_BMS_CAMERAS_ID =
  'c96693d8-88b0-4d66-87e5-272d789ec7d8'
const ALBY_GENERATIVE_PROMPTS_BMS_HAZARDS_ID =
  '52433200-3cc8-427c-ad24-22dbdcd00f5d'
const ALBY_GENERATIVE_PROMPTS_BMS_ADD_ONS_ID =
  '4dab42e3-7502-49b1-8d49-a55bea5c174d'

export {
  ALBY_GENERATIVE_PROMPTS_PLP_ID,
  ALBY_GENERATIVE_PROMPTS_SA_LANDING_ID,
  ALBY_GENERATIVE_PROMPTS_SA_ENTRY_ID,
  ALBY_GENERATIVE_PROMPTS_SA_INDOOR_ID,
  ALBY_GENERATIVE_PROMPTS_SA_OUTDOOR_ID,
  ALBY_GENERATIVE_PROMPTS_PDP_ID,
  ALBY_CHAT_BOT_ID,
  ALBY_CHAT_EXPERIMENT_ID,
  ALBY_GENERATIVE_PROMPTS_FPP_ID,
  ALBY_BRAND_ID,
  ALBY_GENERATIVE_PROMPTS_BMS_BURGLARY_ID,
  ALBY_GENERATIVE_PROMPTS_BMS_CAMERAS_ID,
  ALBY_GENERATIVE_PROMPTS_BMS_HAZARDS_ID,
  ALBY_GENERATIVE_PROMPTS_BMS_ADD_ONS_ID
}
